import * as React from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as mui from "material-ui";
import ContentAdd from "material-ui/svg-icons/content/add";
import * as i18n from "i18n/util";
import { bindStr } from "i18n/util";
import { FormsyText, FormsyCheckbox } from "formsy-material-ui/lib";



export interface IPropsBase {
    title: string;
    message: string;
    labelOk?: string;
    labelCancel?: string;
    onOk?: any;
    onCancel?: any;
}

export interface IProps extends IPropsBase {
    open: boolean;
}

@i18n.injectIntl
@observer
export default class MessageBox extends React.Component<i18n.InjectedIntlProps & IProps, {}> {
    render() {
        const __ = bindStr(this.props.intl);
        const actions = [];
        if (this.props.onCancel) {
            actions.push((
                <mui.FlatButton
                    label={this.props.labelCancel || __("cancel")}
                    primary={true}
                    onTouchTap={this.props.onCancel}
                />));
        }

        if (this.props.onOk) {
            actions.push((
                <mui.FlatButton
                    label={this.props.labelOk || __("ok")}
                    primary={true}
                    onTouchTap={this.props.onOk}
                />));
        }

        return (
            <mui.Dialog
                title={this.props.title}
                actions={actions}
                modal={true}
                open={this.props.open}
            >
                {this.props.message}
            </mui.Dialog>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/MessageBox.tsx